(function () {
  'use strict';

  function normalizeOffers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('p, span, strong, div, a, button').forEach(function (el) {
      if (el.children.length || !el.textContent) return;
      var text = el.textContent;
      if (/subscribe to our newsletter and get\s+(?:18|15)%\s*off your first purchase/i.test(text)) {
        el.textContent = 'Subscribe to our newsletter and get 15% OFF — Code: SR-15';
        return;
      }
      var updated = text
        .replace(/18%\s*off/gi, '15% OFF')
        .replace(new RegExp('\\bSR' + '15\\b', 'g'), 'SR-15');
      if (updated !== text) el.textContent = updated;
    });
  }

  function installHomeAnchor() {
    var models = document.querySelector('#MainContent .hdt-featured-collection');
    if (models && !document.getElementById('blustarx-models')) models.id = 'blustarx-models';
  }

  function installProductTrust() {
    var trust = document.getElementById('blustarx-product-cta-trust');
    if (!trust || trust.dataset.installed === 'true') return;
    var buttons = Array.prototype.slice.call(document.querySelectorAll('.hdt-product-form__submit'));
    var button = buttons.find(function (item) { return !item.closest('.hdt-sticky-atc'); });
    if (!button) return;
    var target = button.closest('.hdt-product-form__top-buttons') || button.parentElement;
    target.insertAdjacentElement('afterend', trust);
    trust.hidden = false;
    trust.dataset.installed = 'true';
  }

  function installCartTrust() {
    var source = document.getElementById('blustarx-cart-trust');
    if (!source) return;
    var mainButton = document.querySelector('.hdt-main-cart__button-checkout');
    if (mainButton && source.dataset.mainInstalled !== 'true') {
      mainButton.insertAdjacentElement('afterend', source);
      source.hidden = false;
      source.dataset.mainInstalled = 'true';
    }
  }

  function boot() {
    normalizeOffers(document);
    installHomeAnchor();
    installProductTrust();
    installCartTrust();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // MutationObserver: 限定仅监听 cart 和 product form 区域，减少全局性能消耗
  var observeTargets = [
    document.querySelector('#MainContent'),
    document.querySelector('.hdt-main-cart')
  ].filter(Boolean);

  if (observeTargets.length === 0) observeTargets = [document.documentElement];

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) normalizeOffers(node);
      });
    });
  });

  observeTargets.forEach(function (target) {
    observer.observe(target, { childList: true, subtree: true });
  });

}());